export const checkForErrors = status => {
  switch (status) {
    case 500:
      return `${status}: Internal server error.`
    case 404:
      return `${status}: Page not found.`
    case 403:
    case 401:
      return `${status}: Operation is unauthorized! Make sure you are logged in first.`
    default:
      return null
  }
}

const defaultRequestOptions = {
  method: 'GET',
  credentials: 'same-origin',
  mode: 'cors',
}

export default async (url, options) => {
  try {
    const response = await fetch(url, { ...defaultRequestOptions, ...options })
    const error = checkForErrors(response.status)

    if (error) {
      throw new Error(error)
    }

    return response.status === 204 ? {} : response.json()
  } catch (error) {
    return {
      error,
    }
  }
}
